import { Typography } from '@customink/pigment-react';
import Alert from '@customink/pigment-react/lib/components/Alert';
import { styled } from '@customink/pigment-react/lib/themeCustomink';

const StyledTypography = styled(Typography)({
  fontSize: '16px',
  lineHeight: '24px',
});

export function AfterVerifiedState() {
  return (
    <>
      <Alert severity="info">
        After submitting your tax exemption documents, we will notify you via
        email with your approval status or any next steps. You can also check
        your status in your Account Settings.
      </Alert>

      <StyledTypography
        component="h5"
        fontWeight="bold"
        lineHeight="20px"
        my="10px"
      >
        If your tax exemption is approved
      </StyledTypography>
      <StyledTypography mb="20px" paragraph>
        In most cases, your tax exemption is approved instantly. Return to your
        cart to mark your purchase as tax exempt to remove sales tax.
      </StyledTypography>
      <StyledTypography
        component="h5"
        fontWeight="bold"
        lineHeight="20px"
        mb="10px"
      >
        If your tax exemption is pending{' '}
      </StyledTypography>
      <StyledTypography paragraph>
        Some states may take up to 3 business days to verify. You will receive
        an email once your status is confirmed.
      </StyledTypography>
    </>
  );
}
